export const SIDEBAR_OPEN = 'sidebar-open';
export const SIDEBAR_CLOSE = 'sidebar-close';
export const DATE_FILTER = 'date-filter';
export const DATE_FILTER_REMOVE = 'date-filter-remove';
export const DATE_FILTER_SERVICE = 'date-filter-service';
export const DATE_FILTER_REMOVE_SERVICE = 'date-filter-remove-service';
export const DATE_FILTER_MARKETING = 'date-filter-marketing';
export const LEAD_COUNT = "lead-count";
